export default __webpack_public_path__ + "static/media/Daily-Earning.0a2ed859.svg";